import { AxiosResponse } from 'axios';
import { DEVICE_INFO_API_URL } from '../../../../config';
import deviceAxios from '../../../../utils/axios/device.axios';

const tryToFetchCompetitors = (
    pageNumber: number,
    pageSize: number,
    data?: any,
    filters?: any,
): Promise<AxiosResponse<any>> => {
    let prepareQuery = ''
    if (filters?.status) {
        prepareQuery = `&status=${filters?.status}`
    }
    if (filters?.type) {
        prepareQuery = prepareQuery + `&type=${filters?.type}`
    }
    const url = prepareQuery !== ''
        ? `${DEVICE_INFO_API_URL}/ai-search-engine/config-competitors?page=${pageNumber}&size=${pageSize}${prepareQuery}`
        : `${DEVICE_INFO_API_URL}/ai-search-engine/config-competitors?page=${pageNumber}&size=${pageSize}`;
    return deviceAxios.put<any>(url, data);
};

const tryToFetchAllCompetitors = (data?: any): Promise<AxiosResponse<any>> => {
    return deviceAxios.put(`${DEVICE_INFO_API_URL}/ai-search-engine/config-competitors/all`, data);
};

const tryToGenerateNewCompetitors = (): Promise<AxiosResponse<any>> => {
    return deviceAxios.put(`${DEVICE_INFO_API_URL}/ai-search-engine/generate-config-competitors`);
};

const tryToAcceptSuggestedCompetitors = (data: any): Promise<AxiosResponse<any>> => {
    return deviceAxios.put(`${DEVICE_INFO_API_URL}/ai-search-engine/competitors-suggested`, data);
};

const tryToEditCompetitor = (data: any): Promise<AxiosResponse<any>> => {
    return deviceAxios.put(`${DEVICE_INFO_API_URL}/ai-search-engine/update-config-competitor`, data);
};

const tryToDeleteCompetitor = (data: any): Promise<AxiosResponse<any>> => {
    return deviceAxios.delete(`${DEVICE_INFO_API_URL}/ai-search-engine/delete-config-competitor/${data?.id}`,);
};

const tryToAddCompetitors = (data: any): Promise<AxiosResponse<any>> => {
    return deviceAxios.put(`${DEVICE_INFO_API_URL}/ai-search-engine/add-search-competitors`, data);
};

export const CompetitorsService = {
    tryToFetchCompetitors,
    tryToGenerateNewCompetitors,
    tryToAcceptSuggestedCompetitors,
    tryToEditCompetitor,
    tryToDeleteCompetitor,
    tryToAddCompetitors,
    tryToFetchAllCompetitors
};